<template>
  <div class="contenedor-lineas-estrategicas">
    <h3 class="titulo-seccion">Líneas estratégicas</h3>

    <div class="lista-lineas-estrategicas">
      <label
        v-for="val in lineasEstrategicas"
        :key="`key-${val.id_linea_estrategica}`"
        :for="`linea_id_${val.id_linea_estrategica}`"
      >
        <input
          type="radio"
          name="lineas_estrategicas"
          :id="`linea_id_${val.id_linea_estrategica}`"
          :value="val.id_linea_estrategica"
          v-model="actualLineaEstrategica"
        />
        {{ val.linea_estrategica_conacyt }}
        <i
          :style="`background-color: ${
            require('@/components/mapas/utiles').coloresLineasEstrategicas[
              val.id_linea_estrategica
            ]
          };`"
        />
        <BotonInfo
          v-if="infoLineasEstrategicas.hasOwnProperty(val.id_linea_estrategica)"
          :contenido="infoLineasEstrategicas[val.id_linea_estrategica]"
          :lado="esMovil ? 'izquierdo' : 'derecho'"
        />
      </label>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BotonInfo from "@/components/utiles/BotonInfo";

export default {
  data: () => ({
    lineasEstrategicas: [
      {
        id_linea_estrategica: "00",
        linea_estrategica_conacyt: "Todas",
      },
      ...require("@/assets/data/diccionarios/lista_lineas_estrategicas.json"),
    ],
    infoLineasEstrategicas: {
      10: "Engloba a todas las personas que no se categorizan en las líneas estratégicas.",
    },
  }),
  methods: {
    ...mapActions("mapaActores", ["cambiarCvesLineaEstrategica"]),
  },
  computed: {
    ...mapGetters("mapaActores", ["actualCveLineaEstrategica"]),
    actualLineaEstrategica: {
      get() {
        return this.actualCveLineaEstrategica;
      },
      set(id_linea) {
        this.cambiarCvesLineaEstrategica(id_linea);
      },
    },
    esMovil() {
      return Boolean(window.innerWidth < 769);
    },
  },
  components: {
    BotonInfo,
  },
};
</script>

<style lang="scss">
.contenedor-lineas-estrategicas {
  /*$web: map-get($media-queries-limit, "mobile") + 1;
  $movil: map-get($media-queries-limit, "mobile");

  @media (min-width: $web) {
    margin-bottom: 50px !important;
  }*/

  .titulo-seccion {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 8px;
  }

  .lista-lineas-estrategicas {
    display: flex;
    flex-direction: column;
    // gap: 8px;

    label {
      $radio-size: 20px;

      font-size: 14px;
      line-height: normal;
      min-height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      padding-left: calc($radio-size + 8px);

      input[type="radio"] {
        display: none;

        + i {
          position: absolute;
          height: $radio-size;
          width: $radio-size;
          // top: 0;
          left: 0;
          border-radius: 50%;

          &:before {
            content: "";
            height: calc($radio-size / 2);
            width: calc($radio-size / 2);
            position: absolute;
            border-radius: 50%;
            top: calc($radio-size / 4);
            left: calc($radio-size / 4);
            transition: all 0.25s ease;
            transform: scale(0);
            opacity: 0;
            background-color: #fff;
          }
        }

        &:checked + i:before {
          transform: scale(1);
          opacity: 1;
        }
      }

      > .boton-info {
        position: absolute;
        right: 0px;
        margin-top: 0px;
        margin-left: 0px;
      }

      &:last-child {
        border-top: 1px solid rgba(0, 0, 0, 0.2);
        padding-top: 8px;
        input[type="radio"] + i {
          top: auto;
        }
      }
    }
  }
}
</style>
